import {captureException, captureMessage, getCurrentScope, init, withScope} from '@sentry/browser';

// Deferred in <head> (pages/headers/_sentry): it runs once the document is parsed, so after gon, and
// before the deferred application bundles of the <body>, whose errors it therefore catches.
const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content;

if (dsn) {
    init({
        dsn,
        // Errors only, as with the former CDN bundle: no tracing or replay integration is bundled.
        dataCollection: {
            // The visitor's IP and the customer email set below.
            userInfo: true,
            // v11 collects both by default; the browser SDK never sent them before, and the tunnel's
            // request bodies carry addresses.
            cookies: false,
            httpBodies: []
        },
        ignoreErrors: [
            'TypeError: Failed to fetch',
            'TypeError: NetworkError when attempting to fetch resource.',
            'TypeError: Load failed',
            'TypeError: Illegal invocation',
            'UnknownError: Background Sync is disabled.',
            'undefined: T([native code])',
            'Error: db',
            'Error: Java bridge method invocation error',
            'TypeError: Cannot read properties of undefined (reading \'onMessage\')',
            /ChunkLoadError/,
            /Trustbadge/,
            /ResizeObserver/,
            /onCleanup/,
            /webkitExitFullScreen/,
            /Failed to read the 'localStorage'/,
            /r\.getClientRects is not a function/,
            /devToolsEnabled/,
            /invalid group specifier name/,
            /NS_ERROR_FAILURE/,
            /NS_ERROR_FILE_ACCESS_DENIED/,
            /The operation is insecure/,
            /captured as promise rejection/,
            /Non-Error promise rejection captured with value/,
            /out of memory/i,
            /Chartboost/i,
            /_AutofillCallbackHandler/i,
            /_pcmBridgeCallbackHandler/i,
            /navigationPerformanceLogger/i,
            /The operation was aborted/i,
            /Unexpected identifier 'https'/i,
            /_PromoCallbackHandler/i,
            /extensionAPIBridge/i,
            /HTMLOUT/i,
            /jb/i,
            /Abgebrochen/i,
            /annulé/i,
            /annullato/i,
            /avbrutt/i,
            /Okta/i,
            /WKWebView/i,
            /webkit/i,
            /AbortError/i,
            /getAttribute/i,
            /RTCPeerConnection/i,
            /shadowRoot/i,
            /sendMessage/i,
            /No identifiers allowed/i,
            /t\.toLowerCase is not a function/i,
            /UET is not defined/i,
            /Unexpected token 'else'/i,
            /Unexpected end of input/i,
            /Java exception/i,
            /Java object is gone/i,
            /evaluating 'a\.K'/i,
            /evaluating 'a\.J'/i,
            /PerformanceObserverInit\.entryTypes/i,
            'Can\'t find variable: UET',
            'Can\'t find variable: gmo',
            /No error message/,
            /getComputedStyle/,
            /finally is not a function/,
            /\$a/,
            /Maximum call stack size exceeded/,
            /webCompat/,
            /masonry is not a function/i,
            /Blocked a frame with origin/i,
            /A network error occurred/i,
            /Importing a module script failed/i,
            /Failed to fetch dynamically imported module/i,
            /error loading dynamically imported module/i,
            /\.track is not a function/i,
            /Unexpected token '\{'/,
            /No currency found/i,
            /SymBrowser_/i,
            /attrchange is not a function/i,
            /prodid value must be within/i,
            /^La$/,
            /\.size is not a function/,
            /feature named `pageContext` was not found/
        ],
        denyUrls: [
            /pagead\/js/i,
            /graph\.facebook\.com/i,
            /connect\.facebook\.net\/en_US/i,
            /extensions\//i,
            /^chrome:\/\//i,
            /^chrome-extension:\/\//i,
            /^safari-extension:\/\//i,
            /^safari-web-extension:\/\//i,
            /^webkit-masked-url:\/\//i,
            /s\.pinimg\.com/i,
            /translate\.googleapis\.com/i,
            /googletagmanager/i,
            /clarity\.ms/i,
            /trustedshops\.com/i,
            /dwin1\.com/i,
            /app\.usercentrics\.eu/i,
            /maps\.googleapis\.com/i,
            /www\.paypal\.com/i,
            /www\.paypalobjects\.com/i,
            /js\.stripe\.com/i,
            /smarttag/i,
            /bat\.bing\.com/i,
            /redditstatic\.com/i,
            /static\.zdassets\.com/i,
            /cookielaw\.org/i,
            /onetrust/i
        ]
    });

    const scope = getCurrentScope();
    const gon = window.gon || {};

    scope.setLevel('warning');

    scope.setTag('locale', gon.locale);
    scope.setTag('iframe', gon.iframe);
    scope.setTag('partner', gon.partner_name);

    if (gon.customer_email) {
        scope.setUser({email: gon.customer_email});
    }
}

// The Sprockets bundles (payment.js) and the React error middleware reach the SDK through these globals.
window.Sentry = {captureException, captureMessage, withScope};
window.SentryCaptureException = captureException;
window.SentryCaptureMessage = captureMessage;
window.SentryWithScope = withScope;
